// We have no support desk and few users, so "contact support" is a prefilled mailto
// carrying the reference and the page URL - the user copies nothing, we get the context.
//
// Surfaces render this address as the link text rather than "email us": operators are on
// managed iPads where `mailto:` can silently do nothing if no mail account is configured,
// and a visible address is still readable and copyable when the tap does nothing.
export const SUPPORT_EMAIL = 'support@balder.co';

export const buildSupportMailto = ({
  referenceId,
  pageUrl,
}: {
  referenceId?: string;
  pageUrl?: string;
}) => {
  const subject = referenceId ? `Balder Cloud error ${referenceId}` : 'Balder Cloud error';
  const body = [
    'What were you doing when this happened?',
    '',
    '',
    '---',
    referenceId ? `Reference: ${referenceId}` : null,
    pageUrl ? `Page: ${pageUrl}` : null,
  ]
    .filter((line) => line !== null)
    .join('\n');

  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
